import { render, staticRenderFns } from "./AdminUtilityInstantTransferDetail.vue?vue&type=template&id=2efea613"
import script from "./AdminUtilityInstantTransferDetail.vue?vue&type=script&lang=ts"
export * from "./AdminUtilityInstantTransferDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports